import React, { useState } from "react";
import Reserve from "../../components/Consultant/Reserve";
import { ReservedTimes, idGenerator, toFarsiNumber } from "../../helper/helper";
import { Rating } from "primereact/rating";

// 1 = user
// 2 = admin
// 3 = cons

// img
import profile from "../../images/avatar.png";
import { useEffect } from "react";
import { getData, postData } from "../../services/API";
import Loading from "../shared/Loading";
import dayjs from "dayjs";
import { Checkbox } from "primereact/checkbox";
import { useContext } from "react";
import { CartDataContext } from "../../contexts/CartContext";
import { Toast } from "primereact/toast";
import { useRef } from "react";
import { Link } from "react-router-dom";
import moment from "moment-jalaali";

const ConsultantCard = ({ data }) => {
  const { cart, setCart } = useContext(CartDataContext);

  const [openTimeReserve, setOpenTimeReserve] = useState(false);
  const [timeReserve, setTimeReserve] = useState([]);
  const [loading, setLoading] = useState(false);
  const [reserveLoading, setReserveLoading] = useState(false);
  const [checkedItems, setCheckedItems] = useState({});
  const [checked2, setChecked2] = useState(false);
  const [paginationLoading, setPaginationLoading] = useState(false);
  const [today, setToday] = useState(true);

  const cartSucc = useRef(null);

  useEffect(() => {
    openTimeReserve && setLoading(true);

    openTimeReserve &&
      postData("/apt/get-times", { id: data.id })
        .then((res) => {
          setLoading(false);
          setTimeReserve(res.data.days);
          setToday(res.data.today);
        })
        .catch((res) => {
          setLoading(false);
        });
  }, [openTimeReserve]);

  const closeTimeModal = () => {
    setOpenTimeReserve(false);
    setTimeReserve([]);
    setCheckedItems({});
  };

  const handleChange = (event) => {
    setCheckedItems({
      ...checkedItems,
      [event.target.name]: event.target.checked,
    });
  };

  const confitmConsTime = () => {
    setReserveLoading(true);
    postData("/apt/reserve", {
      cons_id: data.id,
      times: ReservedTimes(timeReserve, checkedItems),
    })
      .then((res) => {
        cartSucc.current.show({
          severity: "success",
          summary: "زمان مشاوره شما با موفقیت رزرو شد",
          detail: "درحال انتقال به صفحه پرداخت...",
          life: 4000,
        });
      })
      .catch((err) => {
        setReserveLoading(false);
      });
  };

  // page
  const nextWeekTimes = () => {
    setPaginationLoading(true);

    postData("/apt/get-times", {
      id: data.id,
      from_date: timeReserve[timeReserve.length - 1].date,
    })
      .then((res) => {
        setLoading(false);
        setTimeReserve(res.data.days);
        setToday(res.data.today);
        setPaginationLoading(false);
      })
      .catch((res) => {
        setLoading(false);
        setPaginationLoading(false);
      });
  };

  const lastWeekTimes = () => {
    setPaginationLoading(true);

    postData("/apt/get-times", {
      id: data.id,
      last_date: timeReserve[0].date,
      back: true,
    })
      .then((res) => {
        setLoading(false);
        setTimeReserve(res.data.days);
        setToday(res.data.today);
        setPaginationLoading(false);
      })
      .catch((res) => {
        setLoading(false);
        setPaginationLoading(false);
      });
  };

  return (
    <div className="flex justify-center w-full">
      <Toast ref={cartSucc} />

      <div
        onClick={closeTimeModal}
        className={`fixed w-full h-full top-0 bottom-0 right-0 z-20 ${
          openTimeReserve ? "opacity-100 visible" : "opacity-0 invisible"
        } bg-black bg-opacity-50 transition-all duration-300`}
      ></div>

      {/* time schedule */}
      <div
        className={`fixed w-[950px] flex flex-col gap-5 overflow-hidden top-2/4 left-2/4 -translate-x-2/4 -translate-y-2/4 z-30 ${
          openTimeReserve
            ? "opacity-100 visible scale-100"
            : "opacity-0 invisible scale-75"
        } bg-white rounded-2xl transition-all duration-300`}
      >
        <div className="w-full relative text-gray-800 flex justify-center items-center h-14 bg-white shadow-[0px_0px_12px_rgba(77,77,77,0.12)]">
          <span className="text-gray-800 text-xl font-black">
            انتخاب زمان مشاوره
          </span>

          <button
            onClick={closeTimeModal}
            className="outline-none border-none absolute right-5 top-2/4 -translate-y-2/4"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="w-6 h-6 stroke-red-600"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
        <div className="flex flex-col gap-3 px-5">
          {!loading && timeReserve && (
            <div className="flex justify-between items-center px-3">
              {/* prev page */}
              <button
                disabled={today}
                onClick={lastWeekTimes}
                className="flex items-center justify-center disabled:opacity-50 w-8 h-8 bg-gradient-to-tl from-blue-600 to-blue-400 rounded-lg shadow-lg shadow-blue-200 outline-none border-none"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.7"
                  stroke="currentColor"
                  className="w-6 h-6 stroke-white"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3"
                  />
                </svg>
              </button>

              <div className="flex items-center gap-2">
                <span className="text-gray-800 text-xl font-bold">
                  {timeReserve[0] &&
                    toFarsiNumber(timeReserve[0]?.date.slice(-2))}
                </span>
                <span className="text-gray-800 text-xl font-bold">-</span>
                <span className="text-gray-800 text-xl font-bold">
                  {timeReserve[0] &&
                    toFarsiNumber(
                      timeReserve[timeReserve.length - 1]?.date.slice(-2)
                    )}
                </span>
                {/* moment("1392/6/3", "jYYYY/jM/jD").format("YYYY-M-D") */}
                <span className="text-gray-800 text-xl font-bold">
                  {timeReserve[0] &&
                    new Intl.DateTimeFormat("fa-IR", {
                      // year: "numeric",
                      month: "short",
                      // day: "numeric",
                    }).format(
                      new Date(
                        moment(
                          timeReserve[timeReserve.length - 1].date,
                          "jYYYY-jM-jD"
                        ).format("YYYY-M-D")
                      )
                    )}
                </span>
                <span className="text-gray-800 text-xl font-bold">
                  {timeReserve[0] &&
                    toFarsiNumber(
                      timeReserve[timeReserve.length - 1]?.date.slice(0, 4)
                    )}
                </span>
              </div>

              {/* next page */}
              <button
                onClick={nextWeekTimes}
                className="flex items-center justify-center disabled:opacity-50 w-8 h-8 bg-gradient-to-tl from-blue-600 to-blue-400 rounded-lg shadow-lg shadow-blue-200 outline-none border-none"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.7"
                  stroke="currentColor"
                  className="w-6 h-6 stroke-white"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M6.75 15.75L3 12m0 0l3.75-3.75M3 12h18"
                  />
                </svg>
              </button>
            </div>
          )}

          <div className="time-schedule flex relative justify-center overflow-auto h-[600px] gap-4 px-2">
            {/* change page loading */}
            <div
              className={`w-full flex justify-center ${
                paginationLoading
                  ? "opacity-100 visible"
                  : "opacity-0 invisible"
              } transition-all duration-300 items-center absolute bottom-0 z-30 h-full backdrop-blur-sm`}
            >
              <Loading />
            </div>

            {loading ? (
              <div className="flex justify-center items-center w-full h-full">
                <Loading />
              </div>
            ) : (
              timeReserve.map((data) => (
                <div className="w-36 flex flex-col gap-3 h-auto rounded-xl">
                  {/* day */}
                  <div
                    className={`w-full flex text-gray-800 text-[17px] border-t-[5px] border-blue-300 flex-col gap-1 justify-center items-center min-h-[80px] transition-all duration-300 bg-white shadow-[0px_5px_25px_rgba(79,105,139,.09)] rounded-lg`}
                  >
                    <span className="">{toFarsiNumber(data.date)}</span>
                    <span>{data.day}</span>
                  </div>

                  {/* time */}
                  <div className="flex flex-col justify-center items-center gap-3">
                    {data.times.map((time, i) =>
                      time.status === "available" ? (
                        <label
                          // htmlFor={id}
                          className={`w-full ${
                            checkedItems[time.time_id]
                              ? "bg-blue-500 text-white"
                              : "bg-white text-gray-800"
                          } h-20 shadow-[0px_5px_25px_rgba(79,105,139,.09)] cursor-pointer flex flex-col gap-2 justify-center items-center rounded-lg transition-all duration-300`}
                        >
                          <Checkbox
                            className="reserve peer"
                            name={time.time_id}
                            checked={checkedItems[time.time_id]}
                            onChange={handleChange}
                          ></Checkbox>

                          <div className="flex gap-2">
                            <span>{toFarsiNumber(time.hour)}</span>
                          </div>
                        </label>
                      ) : (
                        <label
                          className={`w-full cursor-not-allowed opacity-50 bg-blue-500 text-white h-20 shadow-[0px_5px_25px_rgba(79,105,139,.09)] flex flex-col gap-2 justify-center items-center rounded-lg transition-all duration-300`}
                        >
                          <Checkbox
                            className="peer"
                            name="reserved"
                            checked
                          ></Checkbox>

                          <div className="flex gap-2">
                            <span>رزرو شده</span>
                          </div>
                        </label>
                      )
                    )}
                  </div>
                </div>
              ))
            )}
          </div>
        </div>

        <button
          onClick={confitmConsTime}
          className="w-72 mb-4 self-center transition-all duration-300 h-12 rounded-xl bg-gradient-to-tl from-green-600 to-green-300 shadow-lg shadow-green-200 text-white outline-none border-none"
        >
          {reserveLoading ? (
            <Loading color={"before:!bg-white"} />
          ) : (
            "تایید زمان انتخاب شده"
          )}
        </button>
      </div>

      <div className="max-w-[1300px] w-full">
        <div className="w-full flex h-auto p-5 gap-8 rounded-2xl bg-white shadow-[0px_5px_25px_rgba(79,105,139,.09)]">
          {/* photo */}
          <div className="flex flex-col justify-center items-center h-full gap-4 min-w-[208px]">
            <img
              src={profile}
              className="w-48 h-48 rounded-full object-cover"
              alt=""
            />
            <span className="text-sm text-gray-700 mt-5 block text-center">
              برای مشاهده قیمت، نوع مشاوره را وارد نمایید:
            </span>
            <button className="w-full px-4 py-3 rounded-xl bg-gradient-to-tl from-blue-600 to-blue-400 shadow-lg shadow-blue-200 text-white outline-none border-none">
              انتخاب نوع مشاوره
            </button>
          </div>

          {/* details */}
          <div className="w-full flex flex-col gap-6">
            {/* name */}
            <div className="flex flex-col gap-2">
              <h2 className="text-lg text-gray-800 font-black">
                {data.name + " " + data.family_name}
              </h2>
              <span className="text-gray-700 text-sm">مشاور تایید شده</span>
            </div>

            {/* level */}
            <div className="consultant flex items-center gap-2 text-sm text-gray-700">
              <span>سطح مشاور :</span>
              <Rating
                className="!flex-row-reverse"
                value={4}
                readOnly
                stars={5}
                cancel={false}
              />
            </div>

            {/* consultation method */}
            <div className="flex items-center gap-8">
              <div className="flex items-center text-gray-700 gap-2">
                <div className="flex items-center justify-center w-8 h-8 bg-gradient-to-tl from-blue-600 to-blue-400 rounded-lg shadow-lg shadow-blue-200">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    className="w-5 h-5 fill-white"
                  >
                    <path
                      fillRule="evenodd"
                      d="M2.25 5.25a3 3 0 013-3h13.5a3 3 0 013 3V15a3 3 0 01-3 3h-3v.257c0 .597.237 1.17.659 1.591l.621.622a.75.75 0 01-.53 1.28h-9a.75.75 0 01-.53-1.28l.621-.622a2.25 2.25 0 00.659-1.59V18h-3a3 3 0 01-3-3V5.25zm1.5 0v7.5a1.5 1.5 0 001.5 1.5h13.5a1.5 1.5 0 001.5-1.5v-7.5a1.5 1.5 0 00-1.5-1.5H5.25a1.5 1.5 0 00-1.5 1.5z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>

                <span>مشاوره آنلاین</span>
              </div>

              <div className="flex items-center text-gray-700 gap-2">
                <div className="flex items-center justify-center w-8 h-8 bg-gradient-to-tl from-blue-600 to-blue-400 rounded-lg shadow-lg shadow-blue-200">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    className="w-5 h-5 fill-white"
                  >
                    <path
                      fillRule="evenodd"
                      d="M11.54 22.351l.07.04.028.016a.76.76 0 00.723 0l.028-.015.071-.041a16.975 16.975 0 001.144-.742 19.58 19.58 0 002.683-2.282c1.944-1.99 3.963-4.98 3.963-8.827a8.25 8.25 0 00-16.5 0c0 3.846 2.02 6.837 3.963 8.827a19.58 19.58 0 002.682 2.282 16.975 16.975 0 001.145.742zM12 13.5a3 3 0 100-6 3 3 0 000 6z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>

                <span>مشاوره حضوری - رشت</span>
              </div>
            </div>

            {/* consultation session */}
            <div className="flex items-center gap-8">
              <div className="flex items-center text-gray-700 gap-2">
                <div className="flex items-center justify-center w-8 h-8 bg-gradient-to-tl from-blue-600 to-blue-400 rounded-lg shadow-lg shadow-blue-200">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    className="w-5 h-5 fill-white"
                  >
                    <path
                      fillRule="evenodd"
                      d="M8.25 6.75a3.75 3.75 0 117.5 0 3.75 3.75 0 01-7.5 0zM15.75 9.75a3 3 0 116 0 3 3 0 01-6 0zM2.25 9.75a3 3 0 116 0 3 3 0 01-6 0zM6.31 15.117A6.745 6.745 0 0112 12a6.745 6.745 0 016.709 7.498.75.75 0 01-.372.568A12.696 12.696 0 0112 21.75c-2.305 0-4.47-.612-6.337-1.684a.75.75 0 01-.372-.568 6.787 6.787 0 011.019-4.38z"
                      clipRule="evenodd"
                    />
                    <path d="M5.082 14.254a8.287 8.287 0 00-1.308 5.135 9.687 9.687 0 01-1.764-.44l-.115-.04a.563.563 0 01-.373-.487l-.01-.121a3.75 3.75 0 013.57-4.047zM20.226 19.389a8.287 8.287 0 00-1.308-5.135 3.75 3.75 0 013.57 4.047l-.01.121a.563.563 0 01-.373.486l-.115.04c-.567.2-1.156.349-1.764.441z" />
                  </svg>
                </div>

                <span>{toFarsiNumber(16)} جلسه موفق</span>
              </div>

              <div className="flex items-center gap-3">
                <div className="flex items-center text-white justify-center w-12 h-8 text-xl font-bold bg-gradient-to-tl from-blue-600 to-blue-400 rounded-full shadow-lg shadow-blue-200">
                  {toFarsiNumber(5)}
                </div>

                <span className="text-sm text-gray-700">{`(مشاهده ${toFarsiNumber(
                  10
                )} دیدگاه)`}</span>
              </div>
            </div>

            {/* license */}
            <div className="flex flex-col gap-4">
              <div className="flex items-center text-gray-800 gap-2">
                <div className="flex items-center justify-center w-8 h-8 bg-gradient-to-tl from-blue-600 to-blue-400 rounded-lg shadow-lg shadow-blue-200">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    className="w-5 h-5 fill-white"
                  >
                    <path
                      fillRule="evenodd"
                      d="M5.625 1.5c-1.036 0-1.875.84-1.875 1.875v17.25c0 1.035.84 1.875 1.875 1.875h12.75c1.035 0 1.875-.84 1.875-1.875V12.75A3.75 3.75 0 0016.5 9h-1.875a1.875 1.875 0 01-1.875-1.875V5.25A3.75 3.75 0 009 1.5H5.625zM7.5 15a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5A.75.75 0 017.5 15zm.75 2.25a.75.75 0 000 1.5H12a.75.75 0 000-1.5H8.25z"
                      clipRule="evenodd"
                    />
                    <path d="M12.971 1.816A5.23 5.23 0 0114.25 5.25v1.875c0 .207.168.375.375.375H16.5a5.23 5.23 0 013.434 1.279 9.768 9.768 0 00-6.963-6.963z" />
                  </svg>
                </div>

                <h3 className="text-lg font-extrabold">
                  دکترا مهندسی کامپیوتر گرایش بیوانفورماتیک از دانشگاه تهران
                </h3>
              </div>

              <ul className="list-disc text-gray-700 text-sm flex flex-col gap-2 pr-5">
                <li>سابقه تدریس در دانشگاه به مدت 9 سال</li>
                <li>سابقه تدریس خصوصی</li>
                <li>لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم</li>
              </ul>
            </div>
          </div>

          {/* about */}
          <div className="max-w-[400px] w-full flex flex-col min-h-full justify-between">
            <div className="flex flex-col gap-4">
              <h2 className="about-consultant w-fit pt-4 text-blue-500 font-black relative">
                درباره مشاور
              </h2>

              <p className="text-sm text-gray-700 leading-6 text-justify">
                لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با
                استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله
                در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد
                نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد.
                کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان
                جامعه و متخصصان را می طلبد تا با نرم افزارها شناخت بیشتری را
                برای طراحان رایانه ای علی الخصوص طراحان خلاقی و فرهنگ پیشرو در
                زبان فارسی ایجاد کرد.
              </p>
            </div>

            <div className="flex gap-3">
              <button className="w-full px-4 py-3 rounded-xl bg-gradient-to-tl from-blue-600 hover:-translate-y-1 transition-all duration-300 to-blue-400 shadow-lg shadow-blue-200 text-white outline-none border-none">
                رزومه مشاور
              </button>

              <button
                onClick={() => setOpenTimeReserve(true)}
                className="w-full hover:-translate-y-1 transition-all duration-300 px-4 py-3 rounded-xl bg-gradient-to-tl from-green-600 to-green-300 shadow-lg shadow-green-200 text-white outline-none border-none"
              >
                انتخاب مشاور
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConsultantCard;
